import { useMemo } from 'react';
import {
  FiltersValuesType,
  PaginationFiltersType,
} from 'b2b-apps/shop/catalog/redux/search/types';
import {
  getCatalogSearchQuery,
  getValidPaginationFilters,
  prepareFilters,
} from 'b2b-apps/shop/catalog/utils/filters';

export function useCatalogSearchQuery(
  categoryFilter: string,
  facetFilters: FiltersValuesType,
  paginationFilters: FiltersValuesType,
  searchFilter: string,
): string {
  const { pageSize, page, sorting } = paginationFilters;
  const validFacetFilters = useMemo(
    (): string => prepareFilters(facetFilters),
    [facetFilters],
  );

  const validPaginationFilters = useMemo(
    (): PaginationFiltersType => getValidPaginationFilters(pageSize, page, sorting),
    [pageSize, page, sorting],
  );

  return getCatalogSearchQuery(
    categoryFilter,
    validFacetFilters,
    validPaginationFilters,
    searchFilter,
  );
}
